export const NAVBAR_MENU_BURGER_DEFAULTS = {
  mobileJustify: 'end',
  color: '#171717',
  size: 16,
};
